<div class="modal-header">
    <h4 class="modal-title" id="modal-title">{{title}}</h4>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
        (click)="modal.close(false)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" >
    <div [innerHTML]="text"></div>
</div>
<div class="modal-footer standard-footer">
  <app-standard-footer-buttons
    [secondaryLabel]="cancelText"
    [primaryLabel]="confirmText"
    [showSecondary]="showCancelButton"
    [hidePrimary]="!showConfirmButton"
    (secondaryClick)="modal.close(false)"
    (primaryClick)="modal.close(true)">
  </app-standard-footer-buttons>
</div>
